import { Loader2 } from 'lucide-react';
import { ProgressCircle } from '../../../components/ui/progress-circle';
import { SkillAssessment } from '../../../types/meetinganalysis';

interface SkillScoreCardProps {
  skill: SkillAssessment;
}

// Skill card component
const SkillScoreCard: React.FC<SkillScoreCardProps> = ({ skill }) => {
  return (
    <div className="border border-gray-200 rounded-lg p-6 ">
      <div className="flex items-center mb-4">
        <ProgressCircle
          value={Number(skill.score)}
          maxValue={10}
          size={48}
          className="mr-4"
        />
        <div>
          <h3 className="text-m font-medium">{skill.title}</h3>
          <p className="text-gray-500 text-sm">{skill.description}</p>
        </div>
      </div>

      <div className="h-px bg-gray-200 mb-4" />

      <div>
        <h4 className="text-gray-700 font-semibold mb-2 text-sm">Why</h4>
        <p className="text-gray-600 text-sm mb-4">{skill.explanation}</p>

        <h4 className="text-gray-700 font-semibold mb-2 text-sm">
          What to improve
        </h4>
        <p className="text-gray-600 text-sm">{skill.improvement}</p>
      </div>
    </div>
  );
};

interface SkillAnalysisTabProps {
  skillsAssessment: SkillAssessment[];
  isLoading: boolean;
}

export const SkillAnalysisTab: React.FC<SkillAnalysisTabProps> = ({
  skillsAssessment,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="p-6 flex flex-col justify-center items-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" />
        <span className="mt-4 text-gray-600">Loading skills assessment...</span>
      </div>
    );
  }

  return (
    <div className="p-6">
      {skillsAssessment.length === 0 ? (
        <div className="bg-gray-50 p-8 rounded-lg text-center">
          <p className="text-gray-500">No skills assessment data available.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {skillsAssessment.map((skill, index) => (
            <SkillScoreCard key={index} skill={skill} />
          ))}
        </div>
      )}
    </div>
  );
};
